import { ApiResourceFactory } from '../api.resource.factory'
import { MeasurementsRequestModel, EntityModel, GridModel, GridRequestModel, GridRequestReferenceModel, ImportProgressModel, ImportStatusModel, ImportDataResponseModel, FileModel, FileColumnModel, ContextListModel, SimpleValueModel, CorrespondingActionTypeRequestModel, CorrespondingActionTypeModel, ResponseListModel, FieldNameValueModel } from '../api.models'
import { CommonHelper } from '../../../helpers/common-helper'

export interface IImportService {
    initImport(model: GridModel): ng.IPromise<any>
    validateImport(guid: string): ng.IPromise<ImportStatusModel>
    getImportData(guid: string): ng.IPromise<ImportDataResponseModel>
    startImport(guid: string): ng.IPromise<any>
    stopImport(guid: string): ng.IPromise<any>
    importProgress(guid: string): ng.IPromise<ImportProgressModel>
    importSummary(guid: string): ng.IPromise<any>
    IsImportCompleted(model: GridModel): ng.IPromise<any>
    getImportSummary(model: GridModel): ng.IPromise<any>
}

export interface IAppService {
    getActivities(state?: any): ng.IPromise<GridModel>
    getRoles(state?: any): ng.IPromise<GridModel>
    getReferenceObjectList(req: GridRequestReferenceModel, state?: any): ng.IPromise<GridModel>
    getReferenceObject(req: EntityModel, state?: any): ng.IPromise<any>
    importExcelFile(model: FileColumnModel): ng.IPromise<GridModel>
    getContextList(contextListModel: ContextListModel): ng.IPromise<any[]>
    getCorrespondingActionType(request: CorrespondingActionTypeRequestModel): ng.IPromise<CorrespondingActionTypeModel[]>
    sendAction(action: CorrespondingActionTypeModel): ng.IPromise<any[]>
    saveRequestModel(request: GridRequestModel): ng.IPromise<string>
    saveMeasurementsRequestModel(request: MeasurementsRequestModel): ng.IPromise<string>
    getStates(state: FieldNameValueModel): ng.IPromise<ResponseListModel<number>>    
}

export class AppService implements IAppService {
    constructor(private apiResource: ApiResourceFactory) {

    }

    saveRequestModel(request: GridRequestModel): ng.IPromise<string> {
        var saveRequestModel: ng.resource.IResourceMethod<ng.resource.IResource<SimpleValueModel<string>>> = this.apiResource.app['saveReqModel']
        return saveRequestModel(request).$promise.then((result: SimpleValueModel<string>) => {
            CommonHelper.checkResultError(result)
            return result.value
        })
    }

    saveMeasurementsRequestModel(request: MeasurementsRequestModel): ng.IPromise<string> {
        var saveRequestModel: ng.resource.IResourceMethod<ng.resource.IResource<SimpleValueModel<string>>> = this.apiResource.app['saveMeasReqModel']
        return saveRequestModel(request).$promise.then((result: SimpleValueModel<string>) => {
            CommonHelper.checkResultError(result)
            return result.value
        })
    }

    getStates(state: FieldNameValueModel) {
        // Jałowe zaleczenie wszystkich wystąpień ktore nie przypisują do nameId
        // Zniknie jak pozbędziemy się cienkiego klienta i jałowych modeli
        if (state && (state.nameId == null || isNaN(state.nameId)) && state.idDataType != null) {
            state.nameId = state.idDataType
        }

        var saveRequestModel: ng.resource.IResourceMethod<ng.resource.IResource<ResponseListModel<number>>> = this.apiResource.app['getStates']
        return saveRequestModel(state).$promise.then((result: ResponseListModel<number>) => {
            CommonHelper.checkResultError(result)
            return result
        })
    }

    getActivities(state: any = {}) {
        var get = this.apiResource.app['getActivities']
        state.request = get()
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result);
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getRoles(state: any = {}) {
        var get = this.apiResource.app['getRoles']
        state.request = get()
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result);
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getReferenceObjectList(req: GridRequestReferenceModel, state: any = {}) {
        var get = this.apiResource.secureapp['getReferenceObjectList']
        state.request = get(req)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result);
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getReferenceObject(req: EntityModel, state: any = {}) {
        var get = this.apiResource.secureapp['getReferenceObject']
        state.request = get(req)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result);
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    importExcelFile(model: FileColumnModel) {
        return this.apiResource.app['importExcelFile'](model).$promise.then(result => {
            CommonHelper.checkResultError(result);
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getContextList(contextListModel: ContextListModel): ng.IPromise<any[]> {
        var getContext: ng.resource.IResourceMethod<ng.resource.IResource<any[]>> = this.apiResource.app['getContextList']
        return getContext(contextListModel).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return result
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getCorrespondingActionType(request: CorrespondingActionTypeRequestModel): ng.IPromise<CorrespondingActionTypeModel[]> {
        var method: ng.resource.IResourceMethod<ng.resource.IResource<any[]>> = this.apiResource.app['getCorrespondingActionType']
        return method(request).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return result.map(r => (<any>r).toJSON())
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    sendAction(action: CorrespondingActionTypeModel): ng.IPromise<any[]> {
        var method: ng.resource.IResourceMethod<ng.resource.IResource<any[]>> = this.apiResource.app['sendAction']
        return method(action).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return result.map(r => (<any>r).toJSON())
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status, null, true))
    }
}
